import React from "react";
import { motion } from "framer-motion";
import { HandCoins, Mail, Sparkles } from "lucide-react";

export const DonateSection = () => {
  return (
    <section
      id="aportar"
      className="relative section-dark py-24 md:py-32 overflow-hidden"
      data-testid="donate-section"
    >
      <div aria-hidden className="absolute -top-32 -left-1/4 w-[36rem] h-[36rem] bg-[#F5B400]/10 blur-3xl rounded-full" />
      <div aria-hidden className="absolute inset-0 grid-lines opacity-20" />

      <div className="relative max-w-4xl mx-auto px-5 sm:px-8 lg:px-12 text-center">
        <div className="inline-flex items-center gap-3 mb-5">
          <span className="h-px w-10 bg-[#F5B400]" />
          <span className="font-headings text-xs tracking-[0.3em] uppercase text-[#F5B400]">
            Aportes ciudadanos
          </span>
          <span className="h-px w-10 bg-[#F5B400]" />
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="font-headings font-bold uppercase tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]"
        >
          Aportá a la <span className="text-[#F5B400]">campaña</span>
        </motion.h2>

        <p className="mt-6 text-lg text-white/75 leading-relaxed max-w-2xl mx-auto">
          Frente Ya se financia con aportes de ciudadanos como vos. Cada peso se usa
          para llegar a más gente, imprimir materiales y organizar actividades en
          todo el país.
        </p>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-12 border border-[#F5B400]/40 bg-white/[0.03] p-8 sm:p-12 backdrop-blur-sm"
        >
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#F5B400]/15 border border-[#F5B400]/40 mx-auto mb-6">
            <HandCoins className="text-[#F5B400]" size={28} />
          </div>

          <div className="inline-flex items-center gap-2 mb-4 text-[#F5B400]">
            <Sparkles size={16} />
            <span className="font-headings uppercase tracking-[0.25em] text-xs">
              Próximamente
            </span>
            <Sparkles size={16} />
          </div>

          <h3 className="font-headings uppercase text-2xl sm:text-3xl text-white mb-4">
            Estamos habilitando los aportes online
          </h3>

          <p className="text-white/70 max-w-xl mx-auto leading-relaxed">
            Muy pronto vas a poder aportar por <strong className="text-white">MercadoPago</strong>,{" "}
            <strong className="text-white">transferencia bancaria</strong> y{" "}
            <strong className="text-white">tarjeta</strong>. Mientras tanto, si querés
            colaborar de inmediato, escribinos:
          </p>

          <a
            href="mailto:aportes@frenteya.com.ar?subject=Quiero%20aportar%20a%20la%20campa%C3%B1a"
            className="mt-8 inline-flex items-center gap-3 bg-[#F5B400] hover:bg-[#d99f00] text-[#0A192F] font-headings uppercase tracking-wide text-base px-8 py-4 transition-colors"
            data-testid="donate-email-btn"
          >
            <Mail size={18} />
            Escribir a aportes@frenteya.com.ar
          </a>

          <p className="mt-6 text-xs text-white/40 uppercase tracking-[0.2em] font-headings">
            Toda la rendición de cuentas será pública
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default DonateSection;
